import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";

export interface companyInfo {
    companyId?: string | number | null,
    companyName: string | null,
    companyCode: string | null,
    altitude: string | number | null,
    airTemperature: string | number | null,
    decayCoefficient: string | number | null,
    blowerCapacity: string | number | null,
    clarifierArea: string | number | null,
    anoxicVolume: string | number | null,
    aerobicVolume: string | number | null,
    aerobicDepth: string | number | null,
    yieldCoefficient: string | number | null,
    treatedNitrogen: string | number | null,
    chemical1Label: string | null,
    chemical1Value: string | number | null,
    chemical2Label: string | null,
    chemical2Value: string | number | null,
    chemical3Label: string | null,
    chemical3Value: string | number | null,
    chemical4Label: string | null,
    chemical4Value: string | number | null,
    chemical5Label: string | null,
    chemical5Value: string | number | null,
    biologicalCost: string | number | null,
    energyCost: string | number | null,
    otherMonthlyCost: string | number | null
}


interface StateValue {
    companyInfoDetials: companyInfo
    updateCompanyInfoDetailsData: companyInfo
    setupContent: {}
    setupModelList: []
    dynamicCompanyInfo: []
    updateDynamicCompanyInfo: {}
    getModifiedLableInfo: []
    updateModifiedLableInfo: []
}

const initialState: StateValue = {
    updateDynamicCompanyInfo: {},
    updateModifiedLableInfo: [],
    setupModelList: [],
    getModifiedLableInfo: [],
    companyInfoDetials: {
        companyId: null,
        companyName: null,
        companyCode: null,
        altitude: null,
        airTemperature: null,
        decayCoefficient: null,
        blowerCapacity: null,
        clarifierArea: null,
        anoxicVolume: null,
        aerobicVolume: null,
        aerobicDepth: null,
        yieldCoefficient: null,
        treatedNitrogen: null,
        chemical1Label: null,
        chemical1Value: null,
        chemical2Label: null,
        chemical2Value: null,
        chemical3Label: null,
        chemical3Value: null,
        chemical4Label: null,
        chemical4Value: null,
        chemical5Label: null,
        chemical5Value: null,
        biologicalCost: null,
        energyCost: null,
        otherMonthlyCost: null
    },
    updateCompanyInfoDetailsData: {
        companyId: null,
        companyName: null,
        companyCode: null,
        altitude: null,
        airTemperature: null,
        decayCoefficient: null,
        blowerCapacity: null,
        clarifierArea: null,
        anoxicVolume: null,
        aerobicVolume: null,
        aerobicDepth: null,
        yieldCoefficient: null,
        treatedNitrogen: null,
        chemical1Label: null,
        chemical1Value: null,
        chemical2Label: null,
        chemical2Value: null,
        chemical3Label: null,
        chemical3Value: null,
        chemical4Label: null,
        chemical4Value: null,
        chemical5Label: null,
        chemical5Value: null,
        biologicalCost: null,
        energyCost: null,
        otherMonthlyCost: null
    },
    setupContent: {},
    dynamicCompanyInfo: []
}

const companyInfoSlice = createSlice({
    name: "companyInfo",
    initialState,
    reducers: {
        getCompanyInfoDetailsValue(state, action) {
            state.dynamicCompanyInfo = action.payload
        },
        updateCompanyInfoDetailsValue(state, action) {
            state.updateDynamicCompanyInfo = action.payload
        },
        addSetupContentDataValue(state, action) {
            state.setupContent = action.payload
        },
        getModifiedLableInfoDataValue(state, action) {
            state.getModifiedLableInfo = action.payload
        },
        updateModifiedLableInfoDataValue(state, action) {
            state.updateModifiedLableInfo = action.payload
        },
        getSetupModelListValue(state, action) {
            state.setupModelList = action.payload
        },
        clearSetupModelList(state) {
            state.setupModelList = []
        }
    }
})

export default companyInfoSlice.reducer
export const {
    clearSetupModelList,
} = companyInfoSlice.actions

//Post Company Setup Data
export const addCompanySetupUpload = (payload: any, companyId: string) => {
    return async () => {
        const url = `/setup/upload/${companyId}`
        try {
            const response = await axios.post(url, payload, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            dispatch(companyInfoSlice.actions.addSetupContentDataValue(response.data))
            return response
        } catch (error) {
            return error
            // dispatch(handleSnackbar(error));
        }
    }
}

// Get Model List OF Setup 
export const getSetupModelList = (companyId: string) => {
    return async () => {
        const url = `/setup/models/${companyId}`
        try {
            const response = await axios.get(url)
            dispatch(companyInfoSlice.actions.getSetupModelListValue(response.data))
        } catch (error) {
            dispatch(companyInfoSlice.actions.clearSetupModelList())
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Company Info Details
export const getCompanyInfoDetails = (modelCode: string) => {
    return async () => {
        const url = `/company-info/company-fields/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(companyInfoSlice.actions.getCompanyInfoDetailsValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Update Company Info Details
export const updateCompanyInfoDetails = (payload: any, modelCode: string) => {
    return async () => {
        const url = `/company-info/update-company-model-info/${modelCode}`
        try {
            const response = await axios.put(url, payload)
            dispatch(companyInfoSlice.actions.updateCompanyInfoDetailsValue(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}


//Get Modified Label Details
export const getModifiedLabelDetails = (modelCode: string) => {
    return async () => {
        const url = `/company-info/modifiable-labels/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(companyInfoSlice.actions.getModifiedLableInfoDataValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Update Modified Label Details
export const updateModifiedLabelDetails = (payload: any, modelCode: string) => {
    return async () => {
        const url = `/company-info/modifiable-labels/${modelCode}`
        try {
            const response = await axios.put(url, payload)
            dispatch(companyInfoSlice.actions.updateModifiedLableInfoDataValue(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}
